import { Component, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { CalcsService } from './calcs.service';
import { ComponentCanDeactivate } from './pending-changes-guard.guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements ComponentCanDeactivate {
  title = 'mortgageCalc';

  constructor(
    public calcService: CalcsService) { }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return false
  }
}
